module.exports = __webpack_public_path__ + "img/platform1.601ef878.png";